/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable global-require */

import domReady from 'domready';
import search from './frontpage-search';
import mobileModalWrapper from './mobile-modal-wrapper';

function globalSearch(ele, apiUrl, finnBaseUrl, isMobile) {
    const client = 'WEB';

    if (isMobile) {
        mobileModalWrapper(ele, wrappedEle =>
            search(wrappedEle, apiUrl, finnBaseUrl, client)
        );
    } else {
        search(ele, apiUrl, finnBaseUrl, client);
    }
}

export const globalSearchMobile = (ele, apiUrl, finnBaseUrl) => globalSearch(ele, apiUrl, finnBaseUrl, true);
export const globalSearchDesktop = (ele, apiUrl, finnBaseUrl) => globalSearch(ele, apiUrl, finnBaseUrl, false);

domReady(() => {
    const ele = document.getElementById('global-search');
    const apiUrl = ele.getAttribute('data-base-url') || 'https://www.finn.no';
    const finnBaseUrl = ele.getAttribute('data-finnbase-url') || 'https://www.finn.no';
    globalSearch(ele, apiUrl, finnBaseUrl,  ele.getAttribute('data-is-mobile') === 'true');
});
